import { Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { useContext } from 'react';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import Loader from './components/Loader';

// Pages
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import VideoPage from './pages/VideoPage';
import LoginPage from './pages/LoginPage';
import UploadPage from './pages/UploadPage';

// Context
import AuthContext, { AuthProvider } from './context/AuthContext';

// Error Boundary
import ErrorBoundary from './utils/reactErrorBoundary';

// Compatibility mode to prevent conflicts with browser extensions
window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = { isDisabled: true };

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  
  if (loading) return <div className="d-flex justify-content-center p-5"><Loader /></div>;
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Public Route Component (only for login page)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  
  if (loading) return <div className="d-flex justify-content-center p-5"><Loader /></div>;
  
  return isAuthenticated ? <Navigate to="/" /> : children;
};

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <div className="d-flex flex-column min-vh-100">
          <Header />
          <main className="flex-grow-1">
            <Container fluid className="p-0">
              <Routes>
                <Route 
                  path="/" 
                  element={
                    <ProtectedRoute>
                      <HomePage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/search/:keyword" 
                  element={
                    <ProtectedRoute>
                      <SearchPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/video/:id" 
                  element={
                    <ProtectedRoute>
                      <VideoPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/login" 
                  element={
                    <PublicRoute>
                      <LoginPage />
                    </PublicRoute>
                  } 
                />
                <Route
                  path="/upload"
                  element={
                    <ProtectedRoute>
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </Container>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
